import React from 'react';
import { useTranslation } from 'react-i18next';
import Select, {
  IProps as ISelectProps,
  IValue,
  IValues,
} from './_module/Select';

export default function SelectYesNo<TValue extends IValue | IValues>(
  props: ISelectProps<TValue>
) {
  const { t } = useTranslation();
  const {
    value,
    onChange,
    label,
    required,
    margin,
    error,
    disabled,
    fullWidth,
    helperText,
    isClearable,
    menuPosition,
  } = props;
  const options = [
    {
      label: t('yes'),
      value: (true as unknown) as string,
    },
    {
      label: t('no'),
      value: (false as unknown) as string,
    },
  ];

  return (
    <Select<TValue>
      menuPosition={menuPosition}
      isClearable={isClearable}
      options={options}
      label={label}
      required={required}
      margin={margin}
      error={error}
      disabled={disabled}
      fullWidth={fullWidth}
      helperText={helperText}
      value={value}
      onChange={onChange}
    />
  );
}
